export default {
  header: ['D mm', 'P mm', 'Ø furo'],
  data: [
    ['2', '0,25', '1,75'],
    ['2,2', '0,25', '1,95'],
    ['2,5', '0,35', '2,15'],
    ['3', '0,35', '2,65'],
    ['3,5', '0,35', '3,15'],
    ['4', '0,5', '3,5'],
    ['5', '0,5', '4,5'],
    ['6', '0,75', '5,2'],
    ['7', '0,75', '6,2'],
    ['8', '0,75', '7,2'],
    ['8', '1', '7'],
    ['9', '0,75', '8,2'],
    ['9', '1', '8'],
    ['10', '0,75', '9,2'],
    ['10', '1', '9'],
    ['10', '1,25', '8,8'],
    ['11', '1', '10'],
    ['12', '1', '11'],
    ['12', '1,25', '10,8'],
    ['12', '1,5', '10,5'],
    ['14', '1', '13'],
    ['14', '1,25', '12,8'],
    ['14', '1,5', '12,5'],
    ['15', '1', '14'],
    ['16', '1', '15'],
    ['16', '1,5', '14,5'],
    ['17', '1', '16'],
    ['18', '1', '17'],
    ['18', '1,5', '16,5'],
    ['18', '2', '16'],
    ['20', '1', '19'],
    ['20', '1,5', '18,5'],
    ['20', '2', '18'],
    ['22', '1', '21'],
    ['22', '1,5', '20,5'],
    ['22', '2', '20'],
    ['24', '1', '23'],
    ['24', '1,5', '22,5'],
    ['24', '2', '22'],
    ['25', '2', '23'],
    ['26', '1,5', '24,5'],
    ['27', '1', '26'],
    ['27', '1,5', '25,5'],
    ['27', '2', '25'],
    ['28', '1', '27'],
    ['28', '1,5', '26,5'],
    ['28', '2', '26'],
    ['30', '1', '29'],
    ['30', '1,5', '28,5'],
    ['30', '2', '28'],
    ['30', '3', '27'],
    ['32', '1,5', '30,5'],
    ['32', '2', '30'],
  ],
};
